<script>
  import {
    format,
    endOfDay,
    addDays,
    addBusinessDays,
    startOfTomorrow,
    startOfToday,
    getDay,
  } from "date-fns";
  import TaskApproval from "./taskApproval.svelte";
  import DeclineTask from "./declineTask.svelte";
  import { fade } from "svelte/transition";
  import NewSolderComponent from "./newSolderComponent.svelte";
  import CurrentNbrHours from "./currentNbrHours.svelte";
  import { conversion, lang } from "../store/store";

  import { baseAPIUrl } from "../globals";
  import { authenticatedFetch } from "../appbridge";
  import { db, user } from "../firebase";
  import { doc, getDoc } from "firebase/firestore";
  export let userTasks;
  export let data;

  // CLEAN PARAGRAPHS
  let loading=false;
  console.log("---------------------- TESTING PHASE ----------------------");
  let testParah = userTasks.description;
  let newStr1 = testParah.replace("<p>", "");
  let newStr = newStr1.replace("</p>", "");
  console.log(newStr);
  let convert = (k) => {
    let output = "";
    let hrs = k / 60;
    if (hrs <= 0) {
      hrs = Math.ceil(hrs);
    } else {
      hrs = Math.floor(hrs);
    }
    if (hrs != 0) {
      output = hrs + " " + $conversion[$lang].landing.stats.stat2.hour;
    }
    let minutes = Math.abs(k) - Math.abs(hrs) * 60;
    if (minutes != 0) {
      if (hrs != 0) {
        output =
          output +
          " et " +
          minutes +
          " " +
          $conversion[$lang].landing.stats.stat2.minutes;
      } else {
        output =
          output +
          minutes +
          " " +
          $conversion[$lang].landing.stats.stat2.minutes;
      }
    }
    if (minutes == 0 && hrs == 0) {
      output = "0 " + $conversion[$lang].landing.stats.stat2.minutes;
    }
    return output;
  };
  console.log(userTasks);
  let reason = "";
  let taskApproval = false;
  let taskDecline = false;
  async function handleApproval() {
    loading=true;
    let tempData = {
      taskid: userTasks.taskid,
      availableHrs: data.availableHrs,
      maxEst: userTasks.estimation.maxEst,
      taskname: userTasks.name,
    };
    let response = await authenticatedFetch(
      baseAPIUrl + "/clickup/taskApprove",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tempData),
      }
    ).then((response) => {
      loading=false;
      return response.json();
    });
    loading=false;
    taskApproval = !taskApproval;
  }

  async function handleDecline() {
    let number_messages = Object.entries(userTasks.messages).length;
    console.log(number_messages);
    let tempData = {
      taskid: userTasks.taskid,
      reason: reason,
      messages: number_messages,
      estimation: userTasks.estimation,
      name: userTasks.name,
      description: userTasks.description,
      priority: userTasks.priority.name,
    };
    let response = await authenticatedFetch(
      baseAPIUrl + "/clickup/taskDecline",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tempData),
      }
    ).then((response) => {
      return response.json();
    });
    taskDecline = !taskDecline;
  }

  // let date = format(new Date(parseInt(userTasks.date_created)), "MMM d, uuu");

  let reasonsForRefusing = [
    {
      id: 1,
      reason: $conversion[$lang].taskDecline[3],
      value: $conversion[$lang].taskDecline[3],
    },
    {
      id: 2,
      reason: $conversion[$lang].taskDecline[4],
      value: $conversion[$lang].taskDecline[4],
    },
    {
      id: 3,
      reason: $conversion[$lang].taskDecline[5],
      value: $conversion[$lang].taskDecline[5],
    },
    {
      id: 4,
      reason: $conversion[$lang].taskDecline[6],
      value: $conversion[$lang].taskDecline[6],
    },
  ];

  let selected = false;

  function reasonSelection(data) {
    reason = data;
    if (reason) {
      selected = true;
      document.getElementById("buttonConfirm").disabled = false;
    }
  }

  // If the task is waiting for approval before 9
  // --> we consider that day
  // --> else we have to consider starting from the next day

  //GET INTIAL ACCORDING TO FRANCE ALWAYS

  function TestingFunction() {
    let initialDaytest = new Date();
    console.log(initialDaytest);
    return initialDaytest;
  }

  let initialDay = new Date();
  let intialDayHour = initialDay.getHours();

  let minEstimation;
  let maxEstimation;
  let startDAY;

  let MiNIMUMESTIMATIONDAY;
  let MAXESTIMATIONDAY;

  let MINDAY;
  let MAXDAY;

  let MINDAY_string;
  let MAXDAY_string;

  if (userTasks?.estimation?.minDel) {
    console.log("*****************************************");
    minEstimation = userTasks?.estimation?.minDel;
    maxEstimation = userTasks?.estimation?.maxDel;

    if (intialDayHour < 9) {
      MiNIMUMESTIMATIONDAY = format(
        addBusinessDays(startOfTomorrow(), minEstimation - 1),
        "yyyy-MM-dd"
      );
      MAXESTIMATIONDAY = format(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1),
        "yyyy-MM-dd"
      );

      MINDAY = getDay(addBusinessDays(startOfTomorrow(), minEstimation - 1));
      MINDAY_string = getdateName(MINDAY);

      MAXDAY = MAXDAY = getDay(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1)
      );
      MAXDAY_string = getdateName(MAXDAY);

      startDAY = format(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1),
        "yyyy-MM-dd"
      );
    } else if (intialDayHour > 9) {
      // startDAY = startOfTomorrow();
      // MINDAY = getDay(startDAY);
      // MINDAY_string = getdateName(MINDAY);

      MiNIMUMESTIMATIONDAY = format(
        addBusinessDays(startOfTomorrow(), minEstimation - 1),
        "yyyy-MM-dd"
      );
      MAXESTIMATIONDAY = format(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1),
        "yyyy-MM-dd"
      );

      MINDAY = getDay(addBusinessDays(startOfTomorrow(), minEstimation - 1));
      MINDAY_string = getdateName(MINDAY);

      MAXDAY = MAXDAY = getDay(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1)
      );
      MAXDAY_string = getdateName(MAXDAY);

      startDAY = format(
        addBusinessDays(startOfTomorrow(), maxEstimation - 1),
        "yyyy-MM-dd"
      );
    }
  }
  console.log(userTasks);
  console.log(userTasks);
  console.log(userTasks);
  function getdateName(n) {
    console.log("getting date for " + Number(n));
    switch (Number(n)) {
      case 0:
        return { en: "Sunday", fr: "Dimanche" }[$lang];
        break;
      case 1:
        return { en: "Monday", fr: "Lundi" }[$lang];
        break;
      case 2:
        return { en: "Tuesday", fr: "Mardi" }[$lang];
        break;
      case 3:
        return { en: "Wednesday", fr: "Mercredi" }[$lang];
        break;
      case 4:
        return { en: "Thursday", fr: "Jeudi" }[$lang];
        break;
      case 5:
        return { en: "Friday", fr: "Vendredi" }[$lang];
        break;
      case 6:
        return { en: "Saturday", fr: "Samedi" }[$lang];
        break;
    }
  }

  // ------------------------------------------------------------------- //

  // let today = format(endOfDay(new Date()), "Pp");
  // let today2 = format(endOfDay(new Date()), "k m");
  // let added = format(addDays(endOfDay(new Date()), 6), "Pp");
  // let addedBusinessDays = format(
  //     addBusinessDays(endOfDay(new Date()), 6),
  //     "Pp"
  // );

  let sliced = true;

  function readomore() {
    sliced = false;
  }
  function readless() {
    sliced = true;
  }
</script>

<!-- <h1 on:click={TestingFunction}>Testing Function</h1> -->

<!-- 
{today}
{format(new Date(parseInt(today)), 'MMM d, uuu')} -->

<!-- Today2 :{today2}
<br />
Today :{today}
<br />
Added date :{added}
<br />

addedBusinessDays :
{addedBusinessDays} -->

<!-- Working try -->
<!-- InitialDay hour :
{intialDayHour}
<br />
MIN DAY ESTIMATION :
{MiNIMUMESTIMATIONDAY}
<br />
MINIMUM DAY:
{MINDAY_string}
<br />
Max DAY ESTIMATION :
{MAXESTIMATIONDAY}
<br />
MAXIMUM DAY :
{MAXDAY_string}
<br /> -->
<!--  -->

{#if taskApproval}
  <div
    class="contentWrapper2"
    transition:fade={{ duration: 300 }}
    on:click={() => {
      taskApproval = false;
    }}
  >
    <div class="mainContent" on:click|stopPropagation>
      <div
        class="close"
        on:click={() => {
          taskApproval = false;
        }}
      >
        <i class="bx bx-x" />
      </div>
      <div class="row1">
        <div class="leftSide2">
          <div class="imageContainer">
            <img src="../images/image 14.png" alt="" />
          </div>
        </div>
        <div class="rightSide2">
          <h1>{$conversion[$lang].ApproveComponent[10]} : {userTasks.name}</h1>
          <p class="par1">
            <span>{$conversion[$lang].taskApproval[1]}</span>
            {$conversion[$lang].taskApproval[2]}
            {MINDAY_string}
            ({MiNIMUMESTIMATIONDAY})
            {$conversion[$lang].taskApproval[3]}
            {MAXDAY_string}
            ({MAXESTIMATIONDAY}).
          </p>

          <h4>Description</h4>
          <p class="par2">
            {#if sliced}
              {newStr.slice(0, 120)}
              {#if newStr.length > 235}
                ...
                <span on:click={readomore} class="ReadMoreSpan"
                  >{$conversion[$lang].ApproveComponent[11]}</span
                >
              {/if}
            {:else}
              {newStr.slice(0, newStr.length)}
              <span on:click={readless} class="ReadMoreSpan"
                >{$conversion[$lang].ApproveComponent[12]}</span
              >
            {/if}
          </p>
        </div>
      </div>

      <div class="row2">
        <div class="col1">
          <h5 class="currentNBR">{$conversion[$lang].taskApproval[5]}</h5>

          <CurrentNbrHours bind:data />
        </div>
        <div class="col2">
          <div class="arrowContainer">
            <img src="../images/fast-forward 3.png" alt="" />
          </div>
        </div>
        <div class="col3">
          <h5>{$conversion[$lang].taskApproval[6]}</h5>
          <NewSolderComponent bind:data bind:userTasks />
        </div>
      </div>

      <div class="buttonSide">
        <div class="groupButtons">
          <button
            on:click={() => {
              taskApproval = !taskApproval;
            }}><h5>{$conversion[$lang].taskApproval[11]}</h5></button
          >
          <button
            class="greenButton"
            on:click={() => {
              handleApproval();
            }}
            class:disabled={loading}
            disabled={loading}
          >
            <h5>
              {$conversion[$lang].taskApproval[10]}
              <i class="bx bx-check" />
            </h5>
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}

{#if taskDecline}
  <div
    class="contentWrapper2"
    transition:fade={{ duration: 300 }}
    on:click={() => {
      taskDecline = false;
    }}
  >
    <div class="mainContent" on:click|stopPropagation>
      <!-- <div
                class="close"
                on:click={() => {
                    taskDecline = false;
                }}>
                <i class="bx bx-x" />
            </div> -->

      <div class="part1">
        <div class="topSection">
          <div class="imageContainer2">
            <img src="../images/Frame.png" alt="" />
          </div>
          <p>{$conversion[$lang].taskDecline[1]}</p>
        </div>
        <h5>{$conversion[$lang].taskDecline[2]}</h5>
        <div class="reasonsContainer">
          {#each reasonsForRefusing as reasonItem}
            <div
              class="reason_item"
              on:click={() => reasonSelection(reasonItem)}
            >
              <div
                class={reason.reason === reasonItem.reason
                  ? "cercleSelected"
                  : "cercle"}
              />
              <div class="reasonContent">
                {reasonItem.id}.
                {reasonItem.reason}
              </div>
            </div>
          {/each}

          {#if reason.id == 4}
            <div class="textareaWrapper">
              <div>{$conversion[$lang].taskDecline[9]}</div>
              <textarea
                class="TextAreaReason"
                name=""
                id=""
                cols="2"
                rows="2"
              />
            </div>
          {/if}
        </div>
      </div>
      <div class="buttonSide">
        <div class="groupButtons">
          <button
            on:click={() => {
              taskDecline = !taskDecline;
            }}><h5>{$conversion[$lang].taskDecline[7]}</h5></button
          >
          <button
            disabled
            id="buttonConfirm"
            class={selected ? "greenButton" : "greenButtonNotSelected"}
            on:click={() => {
              handleDecline();
            }}
          >
            <!-- {selected} -->
            <h5>{$conversion[$lang].taskDecline[8]}</h5>
          </button>
        </div>
      </div>
    </div>
  </div>
{/if}

{#if userTasks}
  {#if userTasks.approval == false}
    <div class="ApproveWrapper">
      <div class="contentWrapper">
        <div class="leftSide">
          <!-- {#if userTasks}{userTasks.name}{/if} -->
          <h1>{$conversion[$lang].ApproveComponent[10]} : {userTasks.name}</h1>
          <img src="../images/Startup_Rocket.gif" alt="" />
        </div>

        <div class="rightSide">
          <div class="topPart">
            <h3 class="rightSideTitle">
              {$conversion[$lang].ApproveComponent[1]}
            </h3>

            <p class="rightSideParagraph1">
              {$conversion[$lang].ApproveComponent[2]}
              {convert(userTasks.estimation.minEst)}
              {$conversion[$lang].ApproveComponent[6]}
              {convert(userTasks.estimation.maxEst)}
              maximum.<br />
              <span>{$conversion[$lang].ApproveComponent[3]}</span>
              {$conversion[$lang].ApproveComponent[7]}
              {MINDAY_string}
              ({MiNIMUMESTIMATIONDAY})
              {$conversion[$lang].ApproveComponent[4]}

              {MAXDAY_string}
              ({MAXESTIMATIONDAY}).
            </p>
            <div class="created_at">
              <i class="bx bxs-calendar-alt" />
              <h5>
                {$conversion[$lang].ApproveComponent[5]}
                {format(
                  new Date(parseInt(userTasks.date_created)),
                  "MMM d, uuu"
                )}
              </h5>
            </div>
            <h4 class="descriptionText">Description</h4>
            <p class="rightSideParagraph2">
              {#if sliced}
                {newStr.slice(0, 120)}
                {#if newStr.length > 235}
                  ...
                  <span on:click={readomore} class="ReadMoreSpan"
                    >{$conversion[$lang].ApproveComponent[11]}</span
                  >
                {/if}
              {:else}
                {newStr.slice(0, newStr.length)}
                <span on:click={readless} class="ReadMoreSpan"
                  >{$conversion[$lang].ApproveComponent[12]}</span
                >
              {/if}
            </p>
          </div>
          <div class="buttonSide">
            <div class="groupButtons">
              <button
                on:click={() => {
                  taskDecline = !taskDecline;
                }}><h5>{$conversion[$lang].ApproveComponent[9]}</h5></button
              >
              <button
                class="greenButton"
                on:click={() => {
                  taskApproval = !taskApproval;
                }}
              >
                <h5>{$conversion[$lang].ApproveComponent[8]}</h5>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
{/if}

<style>
  * {
    margin: 0;
    padding: 0;
  }

  .contentWrapper {
    display: flex;
    flex-direction: row;
  }

  .leftSide {
    width: 40%;
  }

  .rightSide {
    width: 60%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .rightSideTitle {
    margin-bottom: 0.5rem;
    font-weight: 500;
    font-size: 1.8em;
    color: rgba(10, 22, 41, 1);
  }

  .rightSideParagraph1 {
    font-weight: 600;
    font-size: 1em;
  }

  .created_at {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 2rem;
    margin-top: 1rem;
  }

  .created_at i {
    font-size: 1.3em;
    color: #7d8592;
    margin-right: 0.5rem;
  }

  .created_at h5 {
    font-size: 0.8em;
    color: #7d8592;
    font-weight: 400;
  }

  .groupButtons {
    display: flex;
    justify-content: flex-end;
  }

  .groupButtons button {
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    background: white;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .groupButtons button h5 {
    font-weight: 500;
    display: flex;
  }

  .rightSideParagraph1 span {
    color: #2c8f73;
  }

  .descriptionText {
    margin-bottom: 1rem;
  }

  .rightSideParagraph2 {
    font-weight: 400;
    width: 90%;
    /* background: red; */
  }
  .greenButton {
    background-color: #2c8f73 !important;
    color: white;
    margin-left: 1rem;
  }

  .greenButtonNotSelected {
    background-color: #74bda8 !important;
    color: white;
    margin-left: 1rem;
  }

  .rightSideParagraph2 span {
    color: #04a9f4;
  }
  .ApproveWrapper {
    background: white;
    padding: 2rem;
    border-radius: 12px;
    margin-bottom: 2rem;
  }

  .contentWrapper2 {
    cursor: pointer;
    background: rgba(46, 41, 78, 0.84);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    z-index: 900;
  }

  .row1 {
    display: flex;
    flex-direction: row;
    margin-bottom: 3rem;
  }

  .leftSide2 {
    width: 30%;
    display: flex;
    align-items: center;
    /* justify-content: center; */
  }

  .rightSide2 {
    width: 70%;
  }

  .imageContainer {
    display: flex;
    /* justify-content: center; */
    align-items: center;
  }

  .imageContainer img {
    width: 80%;
  }

  ::-webkit-scrollbar {
    height: 3.5px;
    width: 0px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
  }
  .mainContent {
    cursor: auto !important;
    position: relative;
    background: white;
    box-shadow: 0px 6px 58px rgba(121, 145, 173, 0.195504);
    border-radius: 24px;
    display: flex;
    flex-direction: column;
    padding: 2rem 8rem 2rem 8rem;
    width: 80%;
    max-width: 70rem;
    max-height: 98%;
    overflow-x: hidden;
  }

  .row2 {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 5rem;
  }

  .rightSide2 h1 {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .par1 {
    font-weight: 600;
    margin-bottom: 1rem;
  }

  .par1 span {
    color: rgba(44, 143, 115, 1);
  }

  .rightSide2 h4 {
    margin-bottom: 0.5rem;
  }

  .par2 span {
    color: rgba(4, 169, 244, 1);
  }

  .currentNBR {
    color: rgba(59, 143, 120, 1);
    margin-bottom: 0.5rem;
  }

  .col1 {
    /* background-color: red; */
    width: 40%;
  }

  .leftContent {
    height: 7rem;

    border: 1px solid #0e8f6c;
    padding: 1rem;
    border-radius: 8px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
  }

  .rightContent {
    /* border: 1px solid #0e8f6c; */
    padding: 1rem;
    color: rgba(171, 92, 92, 1);
    height: 7rem;
    border-radius: 8px;
    background: linear-gradient(
      236deg,
      rgba(171, 92, 92, 0.3),
      rgba(255, 255, 255, 0.59)
    );
  }

  .bloc1 {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-direction: row;
  }

  .leftContent h1 {
    color: rgba(14, 143, 108, 1);
  }

  .col3 {
    width: 40%;
  }

  .col3 h5 {
    margin-bottom: 0.5rem;
  }

  .leftContent i {
    color: rgba(14, 143, 108, 1);
    font-size: 3em;
  }

  .col2 {
    padding-top: 1.5rem;
  }

  .subTitle {
    font-size: 0.9em;
  }

  .currentNBR {
    color: rgba(59, 143, 120, 1);
    margin-bottom: 0.5rem;
  }
  .icon i {
    font-size: 3em;
  }

  .bloc2 {
    font-weight: 400;
    font-size: 0.8em;
    padding-left: 2rem;
  }

  .groupButtons {
    display: flex;
    justify-content: flex-end;
  }

  .groupButtons button {
    cursor: pointer;
    padding: 0.5rem;
    border-radius: 8px;
    background: white;
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .groupButtons button h5 {
    font-weight: 500;
  }

  .greenButton {
    background-color: #2c8f73 !important;
    color: white;
    margin-left: 1rem;
  }

  .greenButton i {
    font-size: 1.5em;
  }

  .close {
    display: flex;
    justify-content: flex-end;
    font-size: 2em;
  }

  .topSection {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .topSection p {
    text-align: center;
    font-size: 1.3rem;
    color: #0a1629;
    margin-top: 1rem;
    margin-bottom: 3rem;
  }

  .reason_item {
    box-shadow: 1px 4px 19px 2px rgba(0, 0, 0, 0.06);
    border-radius: 7px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 1rem 2rem 1rem 2rem;
    margin-bottom: 1rem;
  }

  .cercle {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    /* background-color: #0e8f6c; */
    border: 1px solid rgba(0, 0, 0, 0.17);
    margin-right: 2rem;
    transition: 0.5s ease-in-out;
  }

  .cercleSelected {
    width: 1.7rem;
    height: 1.7rem;
    border-radius: 50%;
    background-color: #0e8f6c;
    border: 1px solid rgba(0, 0, 0, 0.17);
    margin-right: 2rem;
    transition: 0.5s ease-in-out;
  }

  .TextAreaReason {
    border: none;
    width: 100%;
    padding: 1rem;
    border-radius: 8px;
    resize: none;
    box-shadow: 1px 4px 19px 2px rgba(0, 0, 0, 0.06);
  }

  .TextAreaReason:focus {
    outline: none !important;

    border: none;
  }

  .textareaWrapper {
    transition: 0.5s ease-in-out;
    box-shadow: 1px 4px 19px 2px rgba(0, 0, 0, 0.06);
  }

  .part1 {
    overflow-y: auto;
  }

  /* SCROLL BAR */

  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 20px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--primaryColor);
    border-radius: 10px;
  }

  * {
    transition: all 650ms ease-in-out;
  }

  .disabled{
  
    opacity: 0.5;
    transition: opacity 0.8s ease;
    cursor: initial;
  }

  @media only screen and (max-width: 1100px) {
    .rightSide2 {
      width: auto;
      transition: 650ms ease-in-out;
    }

    .rightSideParagraph2 {
      margin-bottom: 1rem;
    }

    .leftSide {
      width: auto;
      transition: 650ms ease-in-out;
    }

    .contentWrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      /* align-items: center; */
    }

    .rightSide {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: auto;
    }

    .leftSide img {
      display: none;
    }

    .leftSide h1 {
      margin-bottom: 3rem;
    }

    .mainContent {
      padding: 1rem 2rem 1rem 2rem;
    }

    .leftSide2 {
      display: none;
    }

    .row2 {
      margin-bottom: 1rem;
      flex-direction: column;
    }
    .col1 {
      width: 100%;
    }

    .col2 {
      padding: 1rem;
    }

    .col3 {
      width: 100%;
    }

    .arrowContainer {
      transform: rotate(90deg);
    }
  }
</style>
